import { alpha, createTheme, responsiveFontSizes } from "@mui/material";
import merge from "lodash/merge";
import { THEMES } from "../constants";
import components from "./components";
import { shadows } from "./shadows";
import themesOptions from "./themeOptions";
const baseOptions = {
  direction: "ltr",
  typography: {
    fontFamily: "'Montserrat', sans-serif",
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 900,
      lg: 1200,
      xl: 1536,
    },
  },
};
export const createCustomTheme = (settings) => {
  /**
   * settings.theme value is 'light' or 'dark'
   * update settings in contexts/settingsContext.tsx
   */
  let themeOptions = themesOptions[settings.theme];

  if (!themeOptions) {
    themeOptions = themesOptions[THEMES.LIGHT];
  }

  if (settings.themeColor) {
    themeOptions.palette.primary.main = settings.themeColor;
    themeOptions.palette.primary[100] = alpha(settings.themeColor, 0.08);
    themeOptions.palette.primary[200] = alpha(settings.themeColor, 0.2);
    themeOptions.palette.primary[300] = alpha(settings.themeColor, 0.3);
    themeOptions.palette.primary[400] = alpha(settings.themeColor, 0.4);
  }

  const mergedThemeOptions = merge({}, baseOptions, themeOptions, {
    direction: settings.direction,
  });
  let theme = createTheme(mergedThemeOptions); // set shadows

  theme.shadows = shadows(theme); // set components

  theme.components = components(theme);

  if (settings.responsiveFontSizes) {
    theme = responsiveFontSizes(theme);
  }

  return theme;
};
